import { render, staticRenderFns } from "./ViewMemberView.vue?vue&type=template&id=2634a615&"
import script from "./ViewMemberView.vue?vue&type=script&lang=js&"
export * from "./ViewMemberView.vue?vue&type=script&lang=js&"
import style0 from "./ViewMemberView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports